module.exports = __webpack_public_path__ + "img/Bandeau3.ffcfe37b.png";